import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Center from "../common/components/Center";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { dependent } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Padding from "../common/components/Padding";

export default function Question2Dependent() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>{t("Do you hate feeling like other people depend on you?")}</h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("That's me")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(dependent(value))}
          rightElement={<p>{t("That's not me")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
